// libs
import * as React from 'react'

// interfaces / constants
import { CLASS_PREFIX } from 'src/constants/'
import {
  DisplaySettings,
  mapDisplayModeToConst,
  POST_DISPLAY_MODE_BANNER,
  PostDisplayMode,
  Purpose
} from 'src/interfaces/posts'

// classes
import NavigationItem from 'src/components/navigation_item/navigation_item'
import Image from 'src/components/post/shared/ingredients/image/image'

// helpers
import DateFormatter from 'src/utils/date_formatter/date_formatter'
import DateHelper from 'src/utils/date_helper/date'

// styles
import { ContentItemFragmentFragment } from '@lopo-tech/lopo-api'
import './image_with_date.scss'

const _classPrefix = `${CLASS_PREFIX}image-with-date__`

interface IDateProps {
  cls: string;
  date: string;
}

const ShortDate: React.FC<IDateProps> = ({ cls, date }) => {
  const textDate: string = DateFormatter.calendarFromDay(date)
  return <div className={`${cls}__short-date`}>{textDate}</div>
}

const Date: React.FC<IDateProps> = ({ cls, date }) => {
  const month: string = DateFormatter.asMonth(date)
  const day: string = DateFormatter.asDay(date)
  return (
    <div className={`${cls}__date`}>
      <div className={`${cls}__day`}>{day}</div>
      <div className={`${cls}__month`}>{month}</div>
    </div>
  )
}

type ImageWithDateSettings = {
  show: boolean;
};

const _settings: DisplaySettings<ImageWithDateSettings> = {
  admin: {
    basic_ingredient: { show: true }
  },
  banner: {
    basic_ingredient: { show: true }
  },
  compact: {
    basic_ingredient: { show: true }
  },
  detail: {
    basic_ingredient: { show: true }
  },
  preview: {
    basic_ingredient: { show: true }
  }
}

type IProps = {
  data: {
    dateString: string;
    images: ContentItemFragmentFragment['attachments'];
  };
  displayMode: PostDisplayMode;
  postDetailsURL?: string;
  postId: string;
  purpose: Purpose;
};

const ImageWithDate: React.FC<IProps> = ({
  data: { dateString, images },
  displayMode,
  postDetailsURL,
  postId,
  purpose
}) => {
  const cls = `${_classPrefix}${mapDisplayModeToConst[displayMode]}`
  const settings = _settings[displayMode][purpose]

  if (!settings?.show) {
    return null
  }

  if (displayMode === POST_DISPLAY_MODE_BANNER) {
    return (
      <NavigationItem target="_self" url={postDetailsURL}>
        <div className={cls}>
          <Image
            data={images}
            displayMode={displayMode}
            postId={postId}
            purpose={purpose}
          />
        </div>
      </NavigationItem>
    )
  } else {
    const renderShortDate = DateHelper.isTodayOrTomorrow(dateString)
    return (
      <NavigationItem target="_self" url={postDetailsURL}>
        <div className={cls}>
          <div className={cls}>
            <Image
              data={images}
              displayMode={displayMode}
              postId={postId}
              purpose={purpose}
            />
          </div>
          {renderShortDate
            ? (
              <ShortDate cls={cls} date={dateString} />
            )
            : (
              <Date cls={cls} date={dateString} />
            )}
        </div>
      </NavigationItem>
    )
  }
}

export default React.memo(ImageWithDate)
